/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type RoleRow_phaseBaselineRole = {
    readonly id: string;
    readonly phaseId: number | null;
    readonly role: {
        readonly id: string;
        readonly name: string | null;
    } | null;
    readonly baselineMinutes: number | null;
    readonly baselinePrice: number | null;
    readonly baselineRatePerHour: number | null;
    readonly baselineCost: number | null;
    readonly baselineCostPerHour: number | null;
    readonly baselineProfit: number | null;
    readonly startYear: number | null;
    readonly startMonth: number | null;
    readonly startDay: number | null;
    readonly deadlineYear: number | null;
    readonly deadlineMonth: number | null;
    readonly deadlineDay: number | null;
    readonly " $refType": "RoleRow_phaseBaselineRole";
};
export type RoleRow_phaseBaselineRole$data = RoleRow_phaseBaselineRole;
export type RoleRow_phaseBaselineRole$key = {
    readonly " $data"?: RoleRow_phaseBaselineRole$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"RoleRow_phaseBaselineRole">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoleRow_phaseBaselineRole",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phaseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Role",
      "kind": "LinkedField",
      "name": "role",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "baselineMinutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "baselinePrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "baselineRatePerHour",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "baselineCost",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "baselineCostPerHour",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "baselineProfit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deadlineYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deadlineMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deadlineDay",
      "storageKey": null
    }
  ],
  "type": "PhaseBaselineRoleType"
};
})();
(node as any).hash = '44518b91e2a91a3d8ed52499cb7d9ccf';
export default node;
